import React from 'react';

const VenueList = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Venues</h1>
      <p className="text-gray-600">Venue listing page - to be implemented</p>
    </div>
  );
};

export default VenueList;

